import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Navbar } from './Navbar'
import { AdminPushPrompt } from '@/components/admin/AdminPushPrompt'
import { AdminPushProvider } from '@/contexts/AdminPushContext'
import { useBlockNumberInputSteppers } from '@/hooks/useBlockNumberInputSteppers'

export function AdminLayout() {
  useBlockNumberInputSteppers()

  return (
    <AdminPushProvider>
      <div className="flex min-h-screen min-h-[100dvh] bg-luxury-950">
        <Sidebar />
        <div className="flex min-w-0 flex-1 flex-col">
          <Navbar />
          <main className="flex-1 overflow-auto p-4 lg:p-6">
            <AdminPushPrompt />
            <Outlet />
          </main>
        </div>
      </div>
    </AdminPushProvider>
  )
}
